<template>
  <v-dialog
    transition="dialog-bottom-transition"
    lazy
    scrollable
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card v-if="timeframe">
      <v-card-title class="pb-0 d-block">
        <v-layout align-center>
          <v-layout
            align-center
            wrap
          >
            <div class="headline mb-2">
              {{ $t('timeframeRelatedContentsDialogTitle') }}
              <span
                v-if="descriptions"
                class="ml-1 grey--text text--darken-1"
              >
                ({{ descriptions.length }})
              </span>
            </div>
          </v-layout>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            data-cy="related-contents-dialog-close-btn"
            icon
            :title="$t('close')"
            @click="closeDialog()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <div class="mt-3 subheading">
          <b>{{ timeframe.start }} - {{ timeframe.end }} {{ timeframe.name }}</b>
        </div>
      </v-card-title>
      <v-card-text>
        <!-- Loading Indicator -->
        <div
          v-if="loading"
          class="loading-indicator mt-5"
        >
          <v-progress-circular
            :size="50"
            indeterminate
            class="msr--text"
          />
        </div>
        <v-list v-if="descriptions.length && !loading">
          <template v-for="(description, descriptionIndex) in descriptions">
            <v-list-tile
              :key="'tile_' + descriptionIndex"
              @click="onDescriptionClicked(description)"
            >
              <v-list-tile-title>
                <v-layout align-center>
                  <v-icon
                    v-if="description.ctype === 'radio'"
                    class="mr-3"
                    color="msr"
                  >
                    music_note
                  </v-icon>
                  <v-icon
                    v-if="description.ctype === 'tv'"
                    class="mr-3"
                    color="msr"
                  >
                    tv
                  </v-icon>
                  <v-icon
                    v-if="description.ctype === 'menucategory'"
                    class="mr-3"
                    color="msr"
                  >
                    menu_book
                  </v-icon>
                  {{ description.title }}
                </v-layout>
              </v-list-tile-title>
            </v-list-tile>
            <v-divider
              v-if="descriptionIndex < descriptions.length - 1"
              :key="'divider_' + descriptionIndex"
            />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    timeframe: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      descriptions: [],
    };
  },
  watch: {
    show: function (show) {
      if (!show) {
        this.reset();
        return;
      }
      if (this.timeframe) {
        this.fetchRelatedContentDescriptions(this.timeframe);
      }
    },
  },
  methods: {
    onDescriptionClicked(description) {
      // RadioSpot, TVSpotBundle
      if (description.ctype == 'tv' || description.ctype == 'radio') {
        this.$router.push(`/spot/${description.ctype}/${description.id}`);
      }
      // MenuCategory
      else if (description.ctype == 'menucategory') {
        this.$router.push({
          name: 'menucategories',
          params: {
            menuId: description.menu_id,
          },
          query: {
            edit: description.id,
          },
        });
      }
    },
    fetchRelatedContentDescriptions(timeframe) {
      this.loading = true;
      this.$api
        .getTimeframeRelatedContentDescriptions(timeframe.id)
        .then((response) => {
          this.descriptions = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.descriptions = [];
    },
    closeDialog() {
      this.reset();
      this.$emit('update:show', false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TimeframeRelatedContentsDialog.vue